import React, { PureComponent, Fragment } from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { beginBookingManagementProcess, openModal } from '../../redux/actions';
import { getProductTypeName, getIconByProductType, Dots, Calendar, Guest, slugify, getBookingStatus } from '../../utils';
import { Link } from '../../routes';

import {
  TicketCard,
  TicketRow,
  TicketPreview,
  TicketContainer,
  TicketHeader,
  TicketMore,
  TicketList,
  TicketItem,
  TicketHeading,
  TicketPrice,
  TicketOptions,
  TicketOption,
  TicketInfo,
  TicketStars,
} from './styles';

const mapDispatchToProps = dispatch => bindActionCreators({
  beginManagementProcess: beginBookingManagementProcess,
  handleModalOpen: openModal,
}, dispatch);

@connect(null, mapDispatchToProps)
class Ticket extends PureComponent {
  static propTypes = {
    hotelPicture: PropTypes.string,
    productName: PropTypes.string,
    neighborhood: PropTypes.string,
    status: PropTypes.number,
    hotelName: PropTypes.string,
    price: PropTypes.number,
    checkinDate: PropTypes.string,
    guestAmount: PropTypes.number,
    bookingId: PropTypes.number,
    beginManagementProcess: PropTypes.func,
    handleModalOpen: PropTypes.func,
    handleMoreClick: PropTypes.func,
    isOpen: PropTypes.bool,
    marketName: PropTypes.string,
    productId: PropTypes.number,
    surveyFinished: PropTypes.bool,
    surveyRating: PropTypes.number,
    maxGuest: PropTypes.number,
    productType: PropTypes.number,
    rateCommend: PropTypes.string,
    usePool: PropTypes.bool,
    useGym: PropTypes.bool,
    useSpa: PropTypes.bool,
    useBusinessCenter: PropTypes.bool,
    isBuyFoodAndDrink: PropTypes.bool,
    foodAndDrinkPrice: PropTypes.number,
    isPayForParking: PropTypes.bool,
    parkingPrice: PropTypes.number,
    isBuySpaService: PropTypes.bool,
    spaServicePrice: PropTypes.number,
    isBuyAdditionalService: PropTypes.bool,
    additionalServicePrice: PropTypes.number,
  };

  constructor(props) {
    super(props)

    this.dropdown = React.createRef();
  };

  componentDidUpdate() {
    this.dropdown = React.createRef();
  };

  onDropdownActionClick = type => {
    const { handleModalOpen,
      beginManagementProcess,
      bookingId,
      hotelPicture,
      productType,
      productName,
      productId,
      guestAmount: productAmount,
      neighborhood,
      hotelName,
      price,
      checkinDate,
      status,
      rateCommend,
      usePool,
      useGym,
      useSpa,
      useBusinessCenter,
      isBuyFoodAndDrink,
      foodAndDrinkPrice,
      isPayForParking,
      parkingPrice,
      isBuySpaService,
      spaServicePrice,
      isBuyAdditionalService,
      additionalServicePrice,
      surveyRating,
      surveyFinished, } = this.props;

    beginManagementProcess({ bookingId,
      hotelPicture,
      productName,
      productType,
      productId,
      productAmount,
      neighborhood,
      hotelName,
      surveyRating,
      price,
      checkinDate,
      status,
      rateCommend,
      usePool,
      useGym,
      useSpa,
      useBusinessCenter,
      isBuyFoodAndDrink,
      foodAndDrinkPrice,
      isPayForParking,
      parkingPrice,
      isBuySpaService,
      spaServicePrice,
      isBuyAdditionalService,
      additionalServicePrice,
      surveyFinished });
    handleModalOpen(type);
  };

  render() {
    const { onDropdownActionClick } = this;
    const {
      hotelPicture,
      productName,
      neighborhood,
      status,
      hotelName,
      price,
      checkinDate,
      guestAmount,
      bookingId,
      handleMoreClick,
      marketName,
      productId,
      surveyFinished,
      surveyRating,
      isOpen,
      maxGuest,
      productType,
    } = this.props;
    const cancelationPeriodCheck = !moment.utc().add(process.env.CANCELING_HOURS,'hour').isAfter(moment.utc(checkinDate).startOf('day'));

    const isActive = status === 0;
    const isRedeemed = status === 2;

    const productsQuantity = Math.ceil(guestAmount/maxGuest);
    const productIcon = getIconByProductType(productType);
    const productTypeName = getProductTypeName(productType, productsQuantity).toLowerCase();

    return (
      <TicketCard>
        {((isActive && cancelationPeriodCheck)  || isRedeemed) && (
          <TicketMore data-id={bookingId} onClick={() => handleMoreClick(bookingId)}>
            <Dots />
          </TicketMore>
        )}
        <TicketOptions shown={isOpen} ref={this.dropdown}>
          {isActive && (
            <Fragment>
              {cancelationPeriodCheck && (
                <Fragment>
                  <li><TicketOption onClick={() => onDropdownActionClick('calendar')}>Change Check-In Date</TicketOption></li>
                  <li><TicketOption onClick={() => onDropdownActionClick('addGuest')}>Add Guests</TicketOption></li>
                </Fragment>
              )}
              {cancelationPeriodCheck && <li><TicketOption red onClick={() => onDropdownActionClick('cancelTicket')}>Cancel Ticket</TicketOption></li>}
            </Fragment>
          )}
          {isRedeemed && <li><TicketOption onClick={() => onDropdownActionClick('review')}>Submit Review</TicketOption></li>}
        </TicketOptions>
        <Link
          route="booking"
          params={{
            marketName: slugify(marketName),
            hotelName: slugify(hotelName),
            productName: slugify(productName),
            productId,
            id: bookingId
          }}
        >
          <a>
            <TicketRow>
              <TicketPreview>
                <img src={`${process.env.CDN_URL}${hotelPicture}`} alt={hotelName} />
              </TicketPreview>
              <TicketContainer>
                <TicketHeader>
                  <TicketList>
                    <TicketItem>{productName}</TicketItem>
                    <TicketItem>{neighborhood}</TicketItem>
                    <TicketItem status={getBookingStatus(status)}>{getBookingStatus(status)}</TicketItem>
                  </TicketList>
                  {surveyFinished && surveyRating ? (
                    <TicketStars>
                      <StarRatings
                        rating={surveyRating}
                        numberOfStars={5}
                        starRatedColor="#1eb6ff"
                        starEmptyColor="#b6e4f9"
                        starDimension="15px"
                        starSpacing="0px"
                      />
                    </TicketStars>
                  ) : null}
                </TicketHeader>
                <TicketHeading>{hotelName}</TicketHeading>
                {price ? <TicketPrice>${price.toFixed(2)}</TicketPrice> : null}
              </TicketContainer>
            </TicketRow>
            <TicketRow>
              <TicketInfo>
                <li>
                  <Calendar /> {moment.utc(checkinDate).format('MMM DD, YYYY')}
                </li>
                <li>
                  <Guest /> {guestAmount * maxGuest} {guestAmount > 1 ? 'guests' : 'guest'}
                </li>
                <li>{productIcon} {guestAmount} {productTypeName}</li>
              </TicketInfo>
            </TicketRow>
          </a>
        </Link>
      </TicketCard>
    );
  }
}

export default Ticket;
